export const IconStudyGraduateHat20: {
  name: 'icon_study_graduate_hat_20-3ca103f36871'
} = {
  name: 'icon_study_graduate_hat_20-3ca103f36871'
}
